<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      商城管理
      <small>/&nbsp;分类列表配置</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->

        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">分类列表</h4>
              </div>
              <!-- end panel-heading -->
             <!-- begin panel-body -->
              <div class="panel-body">
              <form
              
                style="margin-top:16px;padding-left:15px;"
              >
                <fieldset>
                  <div class="form-group row m-b-15">
                    <label class="col-md-1 col-form-label">分类名称</label>
                    <div class="col-md-2">
                      <input
                        type="text"
                        class="form-control"
                        placeholder="分类名称"
                        v-model="fuzzy"
                      >
                    </div>
                    <div class="col-md-1">
                      <a
                        class="btn btn-primary ButtonColor m-r-5"
                        @click="SearchClick()"
                        style="float:right;"
                      >查询</a>
                    </div>
                  </div>
                </fieldset>
              </form>
                <div style="text-align:right;margin-bottom:20px;">
                  <a
                    class="btn btn-primary ButtonColor"
                    @click="AddClick()"
                  >新增</a>
                </div>
                <el-table :data="UserManagementList" border style="width: 100%">
                  <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                  <el-table-column prop="categoryCode" label="分类编号" align="center"></el-table-column>
                  <el-table-column prop="categoryName" label="分类名称" align="center"></el-table-column>
                  <el-table-column prop="weights" label="权重" align="center"></el-table-column>
                  <el-table-column label="操作" width="220" align="center">
                    <template slot-scope="scope">     
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                         :disabled="scope.row.upRecomId"
                        @click="RelevantClick(scope.row)"
                      >关联品牌</button>
                      <button
                        class="btn btn-primary btn-sm ButtonColor"
                        @click="EditClick(scope.row)"
                      >编辑</button>
                      <button
                        class="btn btn-warning btn-sm ButtonColor"
                        @click="DeleteClick(scope.row)"
                      >删除</button>
                 
                    </template>
                  </el-table-column>
                </el-table>
                <div class="PaginationStyle">
                  <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageindex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    background
                    :total="totalCount"
                  ></el-pagination>
                </div>
              </div>
              <!-- end panel-body -->
            </div>
            <!-- end panel -->
          </div>
          <!-- end col-10 -->
        </div>
        <!-- end row -->
      </div>
      <!-- end #content -->
    </div>
    <el-dialog title :visible.sync="outerVisible" width="900px" :before-close="handleClose">
      <div v-if="EditDialog === 3" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">关联品牌</div>
        <form  style="margin-top:16px;">
          <fieldset>
            <div class="form-group row m-b-15">
              <label class="col-md-2 col-form-label">品牌</label>
              <div class="col-md-6">
                <v-selectpage
                  :data="BrandOptions"
                  key-field="brandId"
                  show-field="brandName"
                  v-model="brandId"
                  @values="singleValues"
                  title=""
                ></v-selectpage>
              </div>
            </div>
          </fieldset>
        </form>
        <ul class="BrandTitleUl">
          <li class="BrandTitleCheck" style="width:10%">
            <img
              src="@/assets/UnChecked.svg"
              class="CheckImg"
              v-if="!CheckedShow"
              @click="AllSelectionClick"
            >
            <img
              src="@/assets/Checked.svg"
              class="CheckImg"
              v-if="CheckedShow"
              @click="AllSelectionClick"
            >
          </li>
          <li class="BrandTitle" style="width:15%">品牌编号</li>
          <li class="BrandTitle" style="width:30%">品牌名称</li>
          <li class="BrandTitle" style="width:45%">系列名称</li>
          <li class="clear"></li>
        </ul>
        <ul v-for="(item,index) in BrandList" :key="index" class="BrandTitleUl">
          <li class="BrandContent" @click="handleSelectionClick(item,index)" style="width:10%">
            <img src="@/assets/UnChecked.svg" class="CheckImg" v-if="!item.checked">
            <img src="@/assets/Checked.svg" class="CheckImg" v-if="item.checked">
          </li>
          <li class="BrandContent" style="width:15%">{{item.brandCode}}</li>
          <li class="BrandContent BrandText" style="width:30%">{{item.brandName}}</li>
          <li class="BrandContent" style="width:45%">
            <el-select v-model="item.series" multiple collapse-tags placeholder="请选择" style="width:80%;">
              <el-option
                v-for="itemm in item.goodsSeries"
                :key="itemm.seriesId"
                :label="itemm.seriesName"
                :value="itemm.seriesId">
              </el-option>
            </el-select>
          </li>
          <li class="clear"></li>
        </ul>

        <div class="swal-footer">  
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureRelevant('FormData')"
            >确定</div>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        
        </div>
      </div>
      <div v-if="EditDialog === 2" class="ModelPadding">
        <div class="swal-icon swal-icon--info"></div>
        <div class="swal-title">您确定删除吗?</div>
        <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
        <div class="swal-footer">
          <div class="swal-button-container">
            <button class="swal-button swal-button--confirm btn btn-primary" @click="MakeSure" :disabled = 'disabled'>确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
          
        </div>
      </div>
      <div v-if="EditDialog === 1" class="ModelPadding">
        <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="150px"
          class="demo-ruleForm"
          style="width:90%"
        >
          <el-form-item label="分类编号:" prop="categoryCode">
            <el-input v-model="ruleForm.categoryCode"  class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="分类名称:" prop="categoryName">
            <el-input v-model="ruleForm.categoryName" class="DistributorMargin"></el-input>
          </el-form-item>
          <el-form-item label="权重:" prop="weights">
            <el-input v-model.number="ruleForm.weights" class="DistributorMargin"></el-input>
          </el-form-item>
         
        </el-form>
        <div class="swal-footer">     
          <div class="swal-button-container">
            <button
              class="swal-button swal-button--confirm btn btn-primary"
              @click="MakeSureEdit('ruleForm')"
              :disabled = 'disabled'
            >确定</button>
          </div>
          <div class="swal-button-container">
            <div
              class="swal-button swal-button--cancel btn btn-default"
              @click="outerVisible = false"
            >取消</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <span>您当前正在使用默认分类配置，是否创建自己的分类？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { setTimeout } from "timers";
import { debug } from "util";
export default {
  name: "ClassifiedManagement",
  data() {
    var checkweights = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("权重不能为空"));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error("请输入正整数"));
        } else {
          if (value <= 0) {
            callback(new Error("必须大于0"));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return {
      pageSize: 10,
      totalCount: 0,
      disabled:false,
      CheckedShow: true,
      mark: 0,
      pageindex: 1,
      outerVisible: false,
      DialogTitle: "编辑",
      EditDialog: 1,
      CurrentSelection: [],
      LastArray: [],
      multipleSelection: [],
      multipleSelectArray: [],
      totalArray: [],
      fuzzy: "",
      operator:'1',
      status: "1",
      CloseShow:false,
      distributor: "",
      brandId: "",
      BrandOptions: [],
      StateOptions: [
        {
          label: "删除",
          value: 0
        },
        {
          label: "正常",
          value: 1
        }
      ],
      BrandList: [],
      formdata: {},
      ruleForm: {
        categoryCode: "",
        categoryName: "",
        operator: ""
      },
      rules: {
        categoryCode: [
          { required: true, message: "请输入分类编码", trigger: "blur" }
        ],
        categoryName: [
          { required: true, message: "请输入分类名称", trigger: "blur" }
        ],
        weights: [
          { required: true, validator: checkweights, trigger: "blur" }
        ]
      },
      UserManagementEdit: "",
      TimeValue: "",
      UserManagementList: [],
      currentPage: 1,
      recom_id: "",
      dialogVisible: false,
      seriesId:''
    };
  },
  mounted: function() {
    if(this.$route.query.recomId){
      this.recom_id = this.$route.query.recomId;
    }
    this.initdata();
  },
  methods: {
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    EnterSelect(){
      if(this.status !== '请选择'){
      this.CloseShow = true;
      }
    },
    LeaveSelect(){
     this.CloseShow = false;
    },
    ClearSelect(){
      this.status = '请选择';
    },
    // 全选/反选
    AllSelectionClick() {
      let arr = [];
      this.CheckedShow = !this.CheckedShow;
      if (this.CheckedShow) {
        this.BrandList.forEach(element => {
          if (!element.checked) {
            element.checked = true;
            this.multipleSelection.push(element);
          }
        });
      } else {
        for (var i = 0; i < this.BrandList.length; i++) {
          for (var j = 0; j < this.multipleSelection.length; j++) {
            if (
              this.multipleSelection[j].brandId == this.BrandList[i].brandId &&
              this.BrandList[i].checked
            ) {
              this.multipleSelection.splice(j, 1);
              j = j - 1;
            }
          }
        }

        this.BrandList.forEach(element => {
          element.checked = false;
        });
      }

      this.totalArray = this.multipleSelection;
    },
    // 单选
    handleSelectionClick(value, index) {
      value.checked = !value.checked;
      this.$set(this.BrandList, index, this.BrandList[index]);
      if (value.checked) {
        this.multipleSelection.push(value);
      } else {
        this.multipleSelection.forEach((val, index2) => {
          if (value.brandId == val.brandId) {
            this.multipleSelection.splice(index2, 1);
          }
        });
      }
      this.totalArray = this.multipleSelection;
      //判断是否全选
      let checkedarr = [];
      this.BrandList.forEach(val => {
        if (val.checked) {
          checkedarr.push(val);
        }
      });
      if (checkedarr.length == this.BrandList.length) {
        this.CheckedShow = true;
      } else {
        this.CheckedShow = false;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    EditClick(row) {
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.ruleForm = MethodsBus.cloneRow(row);
    },
    // 根据品牌筛选
    singleValues() {
      let that = this;
      that.outerVisible = true;
      that.EditDialog = 3;
      const options = {
        url: "distribution/B2cGoodsCategoryController/queryBrandCategoryNew",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          categoryId: that.formdata.categoryId,
          brandId: that.brandId,
          conRecomId: that.formdata.recomId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandList = response.data.data;
            let arr = [];
            that.BrandList.forEach(element => {
              if (element.categoryId !== null) {
                element.checked = true;
                arr.push(element);
              } else {
                element.checked = false;
              }
            });
            //判断是否全选
            if (arr.length == that.BrandList.length) {
              that.CheckedShow = true;
            } else {
              that.CheckedShow = false;
            }
          }
        })
        .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 关联按钮，获取数据
    RelevantClick(row) {
      this.formdata = MethodsBus.cloneRow(row);
      let that = this;
      that.outerVisible = true;
      that.EditDialog = 3;
      that.getAllBrand(row);
      var arr = new Array();
      const options = {
        url: "distribution/B2cGoodsCategoryController/queryBrandCategoryNew",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          categoryId: row.categoryId,
          conRecomId: row.recomId
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            response.data.data.forEach(element => {
              if (element.categoryId !== null) {
                element.checked = true;
                arr.push(element);
              } else {
                element.checked = false;
              }
            });
            that.BrandList = response.data.data;
            that.multipleSelection = arr; //当前全部选中的
            that.multipleSelectArray.push(that.multipleSelection);
            that.totalArray = arr;
            //判断是否全选
            if (arr.length == that.BrandList.length) {
              that.CheckedShow = true;
            } else {
              that.CheckedShow = false;
            }
          }else{
             http.handleEorrorCode(response,that);
          }
        })
        .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    // 获取所有品牌
    getAllBrand(row) {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsCategoryController/queryBrandListNew",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          categoryId: row.categoryId,
          recomId: that.recom_id
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandOptions = response.data.data;
          }else{
             http.handleEorrorCode(response,that);
          }
        })
        .catch((error) => {
          http.handleHttpError(error, that);
        });
    },
    DeleteClick(item) {
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    AddClick() {
      this.ruleForm = {};
       if(this.$refs['ruleForm']){
         this.$refs['ruleForm'].resetFields();
      }  
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
    },
    SearchClick() {
       this.pageindex = 1;
      this.initdata();
    },
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        that.$refs[formName]
          .validate(valid => {
            if (valid) {
              that.disabled = true;
              const options = {
                url: "distribution/B2cGoodsCategoryController/updateGoodsCategory",
                method: "post",
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded"
                },
                data: Qs.stringify({
                  recomId: this.recom_id,
                  confirm: 0,
                  categoryId: this.ruleForm.categoryId,
                  categoryCode: this.ruleForm.categoryCode,
                  categoryName: this.ruleForm.categoryName,
                  operator: this.operator,
                  weights: this.ruleForm.weights
                })
              };
              axios(options).then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code === 200) {
                  if(response.data.message == '修改成功'){
                    that.initdata();
                    that.$notify({
                      title: "成功",
                      message: response.data.message,
                      type: "success"
                    });
                  }else{
                    that.dialogVisible = true;
                  }
                } else {
                  http.handleEorrorCode(response,that);
                }
              })
               .catch(function(error) {
                  that.outerVisible = false;
                 that.disabled = false;
                http.handleHttpError(error, that);
              });
            } else {
              this.outerVisible = true;
            }
          })
        
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsCategoryController/addGoodsCategory",
              method: "post",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              data: Qs.stringify({
                recomId: this.recom_id,
                confirm: 0,
                categoryCode: this.ruleForm.categoryCode,
                categoryName: this.ruleForm.categoryName,
                operator: this.operator,
                weights: this.ruleForm.weights
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  if(response.data.message == '新增成功'){
                    that.initdata();
                    that.$notify({
                      title: "成功",
                      message: response.data.message,
                      type: "success"
                    });
                  }else{
                    that.dialogVisible = true;
                  }
                } else {
                  http.handleEorrorCode(response,that);
                }
              })
              .catch(function(error) {
                  that.outerVisible = false;
                 that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      }
    },
    confirmAdd(){
      let that = this;
      if (this.DialogTitle === "编辑") {
        const options = {
          url: "distribution/B2cGoodsCategoryController/updateGoodsCategory",
          // url:"distribution/pointAward/queryPointAward",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify({
            recomId: this.recom_id,
            confirm: 1,
            categoryId: this.ruleForm.categoryId,
            categoryCode: this.ruleForm.categoryCode,
            categoryName: this.ruleForm.categoryName,
            operator: this.operator,
            weights: this.ruleForm.weights
          })
        };
        axios(options).then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code === 200) {
            that.dialogVisible = false;
            that.initdata();
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }else if(this.DialogTitle === "新增"){
        const options = {
          url: "distribution/B2cGoodsCategoryController/addGoodsCategory",
          method: "post",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          },
          data: Qs.stringify({
            recomId: this.recom_id,
            confirm: 1,
            categoryCode: this.ruleForm.categoryCode,
            categoryName: this.ruleForm.categoryName,
            operator: this.operator,
            weights: this.ruleForm.weights
          })
        };
        axios(options)
          .then(function(response) {
            if (response.data.code == 200) {
              that.dialogVisible = false;
              that.initdata();
              that.$notify({
                title: "成功",
                message: response.data.message,
                type: "success"
              });
            } else {
              http.handleEorrorCode(response,that);
            }
          })
          .catch(function(error) {
            http.handleHttpError(error, that);
          });
      }
    },
    MakeSureRelevant() {
      let that=this;
      let arrData = [];
      for (var i =0 ; i<that.totalArray.length; i++){
        //  一定要在循环体内部创建空对象，每循环一次就创建一个 如果在外部申请对象，得到的永远只有一个
        var obj = {};       
        obj.brandId = that.totalArray[i].brandId;
        obj.series = that.totalArray[i].series;
        arrData.push(obj)
      }
      const options = {
        url: "distribution/B2cGoodsCategoryController/addBrandCategoryResNew",
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: {
          categoryId: that.formdata.categoryId,
          data: arrData,
          conRecomId: that.recom_id
        }
      };
      axios(options)
        .then(function(response) {
          that.outerVisible = false;
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    MakeSure() {
      let that = this;
      axios
        .post(
          "distribution/B2cGoodsCategoryController/delGoodsCategory?categoryId=" +
            this.CurrentSelection.categoryId +
            "&recomId=" +
            this.recom_id
        )
        .then(function(response) {
          that.outerVisible = false;
          if (response.data.code === 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    initdata() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsCategoryController/queryGroupByPage",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({
          recomId: that.recom_id,
          fuzzy: that.fuzzy,
          size: that.pageSize,
          current: that.pageindex
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.totalCount = response.data.data.totalCount;
            for (var i in response.data.data.data) {
              response.data.data.data[i].ordernumber =
                Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
            }
            that.UserManagementList = response.data.data.data;
          }else{
             http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
  list-style: none;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.BrandTitle {
  float: left;
  list-style: none;
  color: #909399;
  font-size: 16px;
  line-height: 56px;
  height: 56px;
  font-weight: 400;
}
.BrandTitleCheck {
  float: left;
  list-style: none;
  line-height: 56px;
  height: 56px;
}
.BrandTitleUl {
  border-bottom: 1px solid #ebeef5;
  margin-bottom: 0px;
  padding: 0;
}
.BrandContent {
  float: left;
  list-style: none;
  font-size: 14px;
  color: #606266;
  height: 62px;
  line-height: 62px;
}
.CheckImg {
  width: 16px;
  height: 16px;
  cursor: pointer;
}
.BrandText {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/components/MallPageSetting/ClassifiedManagement.vue